export const ADD_SCREEN = "ADD_SCREEN";

export const ADD_EMPTY_SCREEN = "ADD_EMPTY_SCREEN";

export const REMOVE_SCREEN = "REMOVE_SCREEN";

export const INITIAL_SCREEN = "INITIAL_SCREEN";
